import { render, staticRenderFns } from "./view-attachment.vue?vue&type=template&id=4ef91b28&scoped=true"
import script from "./view-attachment.vue?vue&type=script&lang=js"
export * from "./view-attachment.vue?vue&type=script&lang=js"
import style0 from "./view-attachment.vue?vue&type=style&index=0&id=4ef91b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef91b28",
  null
  
)

export default component.exports